"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asset = void 0;
var buffer_1 = require("buffer");
var lodash_1 = require("lodash");
var ContractId_1 = require("./ContractId");
var Hash_1 = require("./Hash");
var Asset = /** @class */ (function () {
    function Asset(asset) {
        this.asset = asset;
        if (asset === '00') {
            this.version = 0;
            this.cHash = buffer_1.Buffer.alloc(32);
            this.cHash.fill(0);
            this.subType = buffer_1.Buffer.alloc(32);
            this.subType.fill(0);
        }
        else {
            var bytes = buffer_1.Buffer.from(asset, 'hex');
            this.version = bytes.readInt32BE(0);
            this.cHash = buffer_1.Buffer.alloc(32);
            bytes.copy(this.cHash, 0, 4);
            if (bytes.length === 36) {
                this.subType = buffer_1.Buffer.alloc(32);
                this.subType.fill(0);
            }
            else if (bytes.length == 68) {
                this.subType = buffer_1.Buffer.alloc(32);
                bytes.copy(this.subType, 0, 36);
            }
            else {
                throw new Error('invalid asset');
            }
        }
    }
    // static methods
    Asset.isZero = function (bytes) {
        return lodash_1.every(bytes, function (b) { return b === 0; });
    };
    Asset.read = function (buffer, offset) {
        var first = buffer.readUInt8(offset);
        offset++;
        var version = first & 0x1F;
        if ((first & 0x20) !== 0) {
            var _a = this.readVersion(buffer, offset, version * 128, 0), v = _a.version, offset2 = _a.offset;
            version = v;
            offset = offset2;
        }
        var cHash = buffer_1.Buffer.alloc(32);
        if ((first & 0xC0) === 0) {
            cHash.fill(0);
        }
        else {
            offset += buffer.copy(cHash, 0, offset);
        }
        var subType = buffer_1.Buffer.alloc(32);
        switch (first & 0xC0) {
            case 0x0:
            case 0x80:
                subType.fill(0);
                break;
            case 0xC0:
                offset += buffer.copy(subType, 0, offset);
                break;
            default:
                var length = buffer.readUInt8(offset);
                offset++;
                if (length === 0) {
                    subType.fill(0);
                }
                else {
                    subType.fill(0);
                    offset += buffer.copy(subType, 0, offset, offset + length);
                }
                break;
        }
        if (version === 0 && Asset.isZero(cHash) && Asset.isZero(subType)) {
            return { asset: new Asset('00'), offset: offset };
        }
        else if (Asset.isZero(subType)) {
            var b = buffer_1.Buffer.alloc(36);
            b.writeUInt32BE(version, 0);
            cHash.copy(b, 4);
            return { asset: new Asset(b.toString('hex')), offset: offset };
        }
        else {
            var b = buffer_1.Buffer.alloc(36 + 32);
            b.writeUInt32BE(version, 0);
            cHash.copy(b, 4);
            subType.copy(b, 36);
            return { asset: new Asset(b.toString('hex')), offset: offset };
        }
    };
    Asset.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var asset = Asset.read(buffer, 0).asset;
        return asset;
    };
    Asset.defaultOf = function (contractId) {
        return new Asset(contractId.toHex());
    };
    Asset.readVersion = function (buffer, offset, v, counter) {
        if (counter > 3 || (counter !== 0 && v === 0))
            throw new Error('invalid asset version');
        var b = buffer.readUInt8(offset);
        offset++;
        var nextV = v + (b & 0x7F);
        if ((b & 0x80) === 0) {
            return { version: nextV, offset: offset };
        }
        else {
            return this.readVersion(buffer, offset, nextV, counter + 1);
        }
    };
    Asset.prototype.getAsset = function () {
        if (this.asset)
            return this.asset;
        throw new Error("asset is not valid");
    };
    // IType implementation
    Asset.prototype.toJson = function () {
        throw new Error("Method not implemented.");
    };
    Asset.prototype.getSize = function () {
        var versionBytes = this.versionBytes();
        if (Asset.isZero(this.cHash) && Asset.isZero(this.subType)) {
            return versionBytes.length;
        }
        else {
            var index = lodash_1.findLastIndex(this.subType, function (b) { return b !== 0; });
            switch (index) {
                case -1:
                    return versionBytes.length + 32;
                case 30:
                case 31:
                    return versionBytes.length + 32 + 32;
                default:
                    return versionBytes.length + 32 + 1 + index + 1;
            }
        }
    };
    Asset.prototype.write = function (buffer, offset) {
        var versionBytes = this.versionBytes();
        if (Asset.isZero(this.cHash) && Asset.isZero(this.subType)) {
            return offset + versionBytes.copy(buffer, offset);
        }
        else {
            var index = lodash_1.findLastIndex(this.subType, function (b) { return b !== 0; });
            switch (index) {
                case -1:
                    versionBytes[0] = 0x80 | versionBytes[0];
                    offset += versionBytes.copy(buffer, offset);
                    offset += this.cHash.copy(buffer, offset);
                    return offset;
                case 30:
                case 31:
                    versionBytes[0] = 0xC0 | versionBytes[0];
                    offset += versionBytes.copy(buffer, offset);
                    offset += this.cHash.copy(buffer, offset);
                    offset += this.subType.copy(buffer, offset);
                    return offset;
                default:
                    versionBytes[0] = 0x40 | versionBytes[0];
                    offset += versionBytes.copy(buffer, offset);
                    offset += this.cHash.copy(buffer, offset);
                    offset = buffer.writeUInt8(index + 1, offset);
                    offset += this.subType.copy(buffer, offset, 0, index + 1);
                    return offset;
            }
        }
    };
    Asset.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Asset.prototype.toString = function () {
        return this.serialize().toString('hex');
    };
    Asset.prototype.toContractId = function () {
        return new ContractId_1.ContractId(this.version, Hash_1.Hash.fromBuffer(this.cHash));
    };
    Asset.prototype.getSubType = function () {
        return this.subType.toString('hex');
    };
    Asset.prototype.versionBytes = function () {
        var version = this.version;
        function byte(x) {
            return x & 0xFF;
        }
        if ((version & 0xFFFFFFE0) === 0) {
            var b = buffer_1.Buffer.alloc(1);
            b.writeUInt8(version, 0);
            return b;
        }
        else if ((version & 0xFFF80000) === 0) {
            var b = buffer_1.Buffer.alloc(3);
            b.writeUInt8(0x20 | byte(version >>> 14), 0);
            b.writeUInt8(0x80 | byte(version >>> 7), 1);
            b.writeUInt8(0x7F & byte(version), 2);
            return b;
        }
        else if ((version & 0xFC000000) === 0) {
            var b = buffer_1.Buffer.alloc(4);
            b.writeUInt8(0x20 | byte(version >>> 21), 0);
            b.writeUInt8(0x80 | byte(version >>> 14), 1);
            b.writeUInt8(0x80 | byte(version >>> 7), 2);
            b.writeUInt8(0x7F & byte(version), 3);
            return b;
        }
        else {
            var b = buffer_1.Buffer.alloc(5);
            b.writeUInt8(0x20 | byte(version >>> 28), 0);
            b.writeUInt8(0x80 | byte(version >>> 21), 1);
            b.writeUInt8(0x80 | byte(version >>> 14), 2);
            b.writeUInt8(0x80 | byte(version >>> 7), 3);
            b.writeUInt8(0x7F & byte(version), 4);
            return b;
        }
    };
    Asset.Zen = new Asset('00');
    return Asset;
}());
exports.Asset = Asset;
//# sourceMappingURL=Asset.js.map